class CartItems extends HTMLElement {
    constructor() {
      super();

      this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status');

      this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
        .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

      this.debouncedOnChange = debounce((event) => {
        this.onChange(event);
      }, 300);

      this.addEventListener('change', this.debouncedOnChange.bind(this));
    }

    onChange(event) {
      this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'), event.target.dataset.variant, event.target.dataset.currentQuantity, event);
    }

    getSectionsToRender() {
      return [
        {
          id: 'main-cart-items',
          section: document.getElementById('main-cart-items').dataset.id,
          selector: '.js-contents',
        },
        {
          id: 'cart-icon-bubble',
          section: 'cart-icon-bubble',
          selector: '.shopify-section'
        },
        {
          id: 'cart-live-region-text',
          section: 'cart-live-region-text',
          selector: '.shopify-section'
        },
        {
          id: 'main-cart-footer',
          section: document.getElementById('main-cart-footer').dataset.id,
          selector: '.js-contents',
        }
      ];
    }

    async updateQuantity(line, quantity, name, variantId, currentQuantity, event) {
      console.log("MY quantity increased: Qu " + quantity + ">> CQ --- " + currentQuantity);
      const body = JSON.stringify({
        line,
        quantity,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      });

      // block add to cart per location inventory
      // const location = window.localStorage.getItem('__mednow_user_city') || 'Ontario';
      const location = Alpine.store('location').city;
      const locale = document.body.dataset.locale;
   //   const availableInLocation = await fetch(`https://mednow-inventory.herokuapp.com/?variant=${variantId}&location=${location}`).then(res => res.json());
  //    const availableQty = availableInLocation.node.available;

      
      // Per order limit
      const getOrderLimitBool = event.target.dataset.orderlimit;
      const getLimitPerOrder = event.target.dataset.limitperorder;

      const orderLimit = (typeof getOrderLimitBool !== "undefined" && getOrderLimitBool != "") ? getOrderLimitBool : false;
      const limitPerOrder = (typeof getLimitPerOrder !== "undefined" && getLimitPerOrder != "") ? getLimitPerOrder : 2;

      // console.log(typeof getLimitPerOrder);
      // console.log(limitPerOrder);

      if(orderLimit && quantity > limitPerOrder) {
        const errorWrapper = document.querySelector('.cart-item-error-' + variantId);

        errorWrapper.removeAttribute('hidden');
        const enErrString = `The limit for this product is ${limitPerOrder} units per order.`;
        const frErrString = `La limite pour ce produit est de ${limitPerOrder} unités par commande.`;
        errorWrapper.querySelector('span').innerHTML = locale === 'en' ? enErrString : frErrString;
        event.target.value = currentQuantity;
        return;
      }
/*
      if (quantity > availableQty) {
        const itemInCart = quantity - 1;
        const errorWrapper = document.querySelector('.cart-item-error-' + variantId);

        errorWrapper.removeAttribute('hidden');

//         errorWrapper.querySelector('span').innerHTML = `Only ${availableQty} ${availableQty > 1 ? 'items are' : 'item is'} available at your location and ${currentQuantity} ${currentQuantity > 1 ? 'items are' : 'item is'} already in your cart!`;

        if (availableQty > 0) {
        	const enErrString = `Only ${availableQty ? availableQty : 0} ${availableQty > 1 ? 'items are' : 'item is'} available at your location.`;
            const frErrString = `Seuls ${availableQty ? availableQty : 0} ${availableQty > 1 ? 'articles' : 'article'} sont disponibles chez vous.`;
            errorWrapper.querySelector('span').innerHTML = locale === 'en' ? enErrString : frErrString;
        } else {
        	const enErrString = `No items available at your location.`;
            const frErrString = `Aucun article disponible à votre emplacement.`;
            errorWrapper.querySelector('span').innerHTML = locale === 'en' ? enErrString : frErrString;
        }
        
        event.target.value = currentQuantity;
        return;
      }

  */
      fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          document.dispatchEvent(new CustomEvent('cart:updated'));
          const parsedState = JSON.parse(state);
          this.classList.toggle('is-empty', parsedState.item_count === 0);
          const cartFooter = document.getElementById('main-cart-footer');

          if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);

          this.getSectionsToRender().forEach((section => {
            const elementToReplace =
              document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

            elementToReplace.innerHTML =
              this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
          }));

          this.updateLiveRegions(line, parsedState.item_count);
          const lineItem =  document.getElementById(`CartItem-${line}`);
          if (lineItem && lineItem.querySelector(`[name="${name}"]`)) lineItem.querySelector(`[name="${name}"]`).focus();
          this.disableLoading();
        }).catch(() => {
          this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        }).finally(() => {
            document.querySelector("cart-drawer").updateTax();
        	// clear tick mark from product grid on remove
            this.clearTickMark(quantity, variantId);
        });
    }

    clearTickMark(quantity, variantId) {
      console.log('from clear tick mark');
    	// remove tickmark from grid item
          if (quantity == 0) {
            console.log('quantity got 0')
            console.log(document.querySelector('.card-quick-add-'+ variantId))
            document.querySelectorAll('.card-quick-add-'+ variantId).forEach(el => {
            	el.classList.remove('added');
            })
          }
    }

    updateLiveRegions(line, itemCount) {
      if (this.currentItemCount === itemCount) {
        document.getElementById(`Line-item-error-${line}`)
          .querySelector('.cart-item__error-text')
          .innerHTML = window.cartStrings.quantityError.replace(
            '[quantity]',
            document.getElementById(`Quantity-${line}`).value
          );
      }

      this.currentItemCount = itemCount;
      this.lineItemStatusElement.setAttribute('aria-hidden', true);

      const cartStatus = document.getElementById('cart-live-region-text');
      cartStatus.setAttribute('aria-hidden', false);

      setTimeout(() => {
        cartStatus.setAttribute('aria-hidden', true);
      }, 1000);
    }

    getSectionInnerHTML(html, selector) {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
  }

  customElements.define('cart-items', CartItems);

  class CartDrawer extends CartItems {
    constructor() {
      super();
      this.updateTax();
      console.log("variant ID this is " + this.target?.dataset?.variant);
    }


    updateTax() {
      console.log("updating")
      const location = JSON.parse(window.localStorage.getItem("location_city"));
      if (location === "Quebec") {
        if (this.querySelector(".tax__gst")) this.querySelector(".tax__gst").classList.remove("hidden");
        if (this.querySelector(".tax__hst")) this.querySelector(".tax__hst").classList.add("hidden");
        const productsInfo = document.querySelectorAll('.product-link');
        productsInfo.forEach((prod, index) => {
            let newhref = prod.attributes['href'].value;
            if (newhref.includes("qc-pdp") == false) {
                newhref = newhref + '&view=qc-pdp';
                prod.setAttribute('href', newhref);
            }
            console.log(newhref);
        });
      }
    }
    
    getSectionsToRender() {
      return [
        {
          id: 'cart-drawer',
          section: document.getElementById('drawer-cart-items').dataset.id,
          selector: '.js-contents',
        },
        {
          id: 'cart-icon-bubble',
          section: 'cart-icon-bubble',
          selector: '.shopify-section'
        },
        {
          id: 'cart-live-region-text',
          section: 'cart-live-region-text',
          selector: '.shopify-section'
        }
      ];
    }
  }

  customElements.define('cart-drawer', CartDrawer);